module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gc-Hc-Id-Ja.543a80e7.png";